import React from 'react';
import DishCard from './DishCard';

const CategorySection = ({ category, dishes, onViewDetails, onViewAR }) => {
  if (dishes?.length === 0) return null;

  return (
    <section className="category-section mb-8 md:mb-10 lg:mb-12">
      <div className="category-header mb-4 md:mb-6">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground">
          {category?.name}
        </h2>
        {category?.description && (
          <p className="text-sm md:text-base text-muted-foreground mt-2">
            {category?.description}
          </p>
        )}
      </div>
      <div className="category-dishes-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
        {dishes?.map((dish) => (
          <DishCard
            key={dish?.id}
            dish={dish}
            onViewDetails={onViewDetails}
            onViewAR={onViewAR}
          />
        ))}
      </div>
    </section>
  );
};

export default CategorySection;